import { Typography, Skeleton } from '@mui/material';
import { Stack, Box, StackProps } from '@mui/system';
import { ClubLogo } from '@scorenco/components';
import { RouteLink, Types } from '@scorenco/core';

import { getEventTeams } from '../utils/eventGuards';

type EventTeamProps = StackProps & {
  event?: Types.Competitions_Event_Detail;
  isAway?: boolean;
  tournamentUrl?: string;
};

export const EventTeam = ({
  event,
  tournamentUrl,
  isAway,
  ...rest
}: EventTeamProps) => {
  const teamIndex = isAway ? 1 : 0;
  const teams = getEventTeams(event?.teams);

  return (
    <Stack
      flex={1}
      gap={2}
      alignItems={{ xs: isAway ? 'end' : 'start', sm: 'center' }}
      flexDirection={{ xs: 'column', sm: isAway ? 'row-reverse' : 'row' }}
      {...rest}
    >
      <Box component={RouteLink} href={tournamentUrl || teams[teamIndex]?.url}>
        <ClubLogo
          sx={{
            width: {
              xs: '4rem',
              sm: '6rem',
              lg: '8rem',
            },
            height: {
              xs: '4rem',
              sm: '6rem',
              lg: '8rem',
            },
            objectPosition: isAway ? 'right' : 'left',
            cursor: 'pointer',
          }}
          logo={teams[teamIndex]?.logo}
          name={teams[teamIndex]?.name_in_competition}
          shieldColor={isAway ? 'away' : 'home'}
          width={200}
          height={200}
        />
      </Box>

      <Typography
        component={RouteLink}
        href={tournamentUrl || teams[teamIndex]?.url}
        variant="body1"
        textAlign={isAway ? 'right' : 'left'}
        sx={{
          textDecoration: 'none',
          color: 'inherit',

          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {teams[teamIndex]?.name_in_club || (
          <Skeleton width={100} sx={isAway ? { mr: 0, ml: 'auto' } : {}} />
        )}
      </Typography>
    </Stack>
  );
};
